// extracted by mini-css-extract-plugin
export default {"zoomModal":"Z0-z"};